export const ENTITY = {
    EVENT: '/event',
    ROLE: '/role',
    KNOWLEDGE_BASE: "/knowledgeBase",
    USER: '/user',
    REPORT: '/report',
    RECOMMENDATION: '/recommendation',
    FEEDBACK: '/feedback',
    FORM30: '/form30',
} as const;

export const METHOD = {
    CREATE: '/create',
    UPDATE: '/update',
    DELETE: '/delete',
    FETCH: '/get',
    FETCH_SHORT: '/getShort',
    FETCH_BY_SECTOR: '/getSector',
    FETCH_SUB_USERS_BY_SECTOR: '/getSubUsersBySector',
    FETCH_LOGS: '/getLogs',
    FETCH_CHART_DATA: '/getChartData',
    FETCH_PLAN_CHART_DATA: '/getPlanChartData',
    FETCH_ALL_EXCEL: '/getAllExcel',
    GET_BY_OWNER: '/getOwner',
    FETCH_FOLDERS: '/getFolders',
    FETCH_FOLDER_FILE: '/getFiles',
    GET_FOLDER_BY_ID: '/getFolder',
    CREATE_FOLDER: '/createFolder',
    UPDATE_FOLDER: '/updateFolder',
    DELETE_FOLDER: '/deleteFolder',
    UPLOAD_FILE: '/uploadFile',
    UPLOAD_VIDEO: '/uploadVideo',
    CREATE_LINK: '/createLink',
    DELETE_FILE: '/deleteFile',
    GET_FILE: '/getFile',
    GET_COVER:"/getCover",
    FETCH_USER_BY_EMAIL: '/usersByEmail',
    UPSERT_REPORT: '/upsertReport',
    ADD_COMMENT: '/addComment',
    CHANGE_STATUS: '/changeStatus',
    SET_READ: '/setRead',
    GET_UNREAD_RECOMMS: '/getUnread',
} as const;

export const buildEndpoint = (entity: string, method: string): string => {
    return `${entity}${method}`;
};
export const USER_ENDPOINTS = {
    FETCH_USER_BY_EMAIL: buildEndpoint(ENTITY.USER, METHOD.FETCH_USER_BY_EMAIL),
} as const;

// Event endpoints
export const EVENT_ENDPOINTS = {
    CREATE: buildEndpoint(ENTITY.EVENT, METHOD.CREATE),
    UPDATE: buildEndpoint(ENTITY.EVENT, METHOD.UPDATE),
    DELETE: buildEndpoint(ENTITY.EVENT, METHOD.DELETE),
    FETCH_EVENTS: buildEndpoint(ENTITY.EVENT, METHOD.FETCH),
} as const;

export const KNOWLEDGE_BASE_ENDPOINTS = {
    CREATE_FOLDER: buildEndpoint(ENTITY.KNOWLEDGE_BASE, METHOD.CREATE_FOLDER),
    UPDATE_FOLDER: buildEndpoint(ENTITY.KNOWLEDGE_BASE, METHOD.UPDATE_FOLDER),
    DELETE_FOLDER: buildEndpoint(ENTITY.KNOWLEDGE_BASE, METHOD.DELETE_FOLDER),
    FETCH_FOLDERS: buildEndpoint(ENTITY.KNOWLEDGE_BASE, METHOD.FETCH_FOLDERS),
    FETCH_FOLDER_BY_ID: buildEndpoint(ENTITY.KNOWLEDGE_BASE, METHOD.GET_FOLDER_BY_ID),
    FETCH_FOLDER_FILES: buildEndpoint(ENTITY.KNOWLEDGE_BASE, METHOD.FETCH_FOLDER_FILE),
    UPLOAD_FILE: buildEndpoint(ENTITY.KNOWLEDGE_BASE, METHOD.UPLOAD_FILE),
    UPLOAD_VIDEO: buildEndpoint(ENTITY.KNOWLEDGE_BASE, METHOD.UPLOAD_VIDEO),
    CREATE_LINK: buildEndpoint(ENTITY.KNOWLEDGE_BASE, METHOD.CREATE_LINK),
    DELETE_FILE: buildEndpoint(ENTITY.KNOWLEDGE_BASE, METHOD.DELETE_FILE),
    GET_FILE: buildEndpoint(ENTITY.KNOWLEDGE_BASE, METHOD.GET_FILE),
    GET_COVER: buildEndpoint(ENTITY.KNOWLEDGE_BASE, METHOD.GET_COVER),
} as const;

export const ROLE_ENDPOINTS = {
    GET_BY_OWNER: buildEndpoint(ENTITY.ROLE, METHOD.GET_BY_OWNER),
} as const;

export const REPORT_ENDPOINTS = {
    UPSERT: buildEndpoint(ENTITY.REPORT, METHOD.UPSERT_REPORT),
    FETCH: buildEndpoint(ENTITY.REPORT, METHOD.FETCH),
    FETCH_ALL_EXCEL: buildEndpoint(ENTITY.REPORT, METHOD.FETCH_ALL_EXCEL),
    FETCH_LOGS: buildEndpoint(ENTITY.REPORT, METHOD.FETCH_LOGS),
    FETCH_CHART_DATA: buildEndpoint(ENTITY.REPORT, METHOD.FETCH_CHART_DATA),
    FETCH_PLAN_CHART_DATA: buildEndpoint(ENTITY.REPORT, METHOD.FETCH_PLAN_CHART_DATA),
} as const;

export const RECOMMENDATION_ENDPOINTS = {
    FETCH_SHORT: buildEndpoint(ENTITY.RECOMMENDATION, METHOD.FETCH_SHORT),
    FETCH_BY_SECTOR: buildEndpoint(ENTITY.RECOMMENDATION, METHOD.FETCH_BY_SECTOR),
    GET: buildEndpoint(ENTITY.RECOMMENDATION, METHOD.FETCH),
    ADD_COMMENT: buildEndpoint(ENTITY.RECOMMENDATION, METHOD.ADD_COMMENT),
    CHANGE_STATUS: buildEndpoint(ENTITY.RECOMMENDATION, METHOD.CHANGE_STATUS),
    SET_READ: buildEndpoint(ENTITY.RECOMMENDATION, METHOD.SET_READ),
    CREATE: buildEndpoint(ENTITY.RECOMMENDATION, METHOD.CREATE),
    DELETE: buildEndpoint(ENTITY.RECOMMENDATION, METHOD.DELETE),
    UPDATE: buildEndpoint(ENTITY.RECOMMENDATION, METHOD.UPDATE),
    GET_FILE: buildEndpoint(ENTITY.RECOMMENDATION, METHOD.GET_FILE),
    GET_UNREAD_RECOMMS: buildEndpoint(ENTITY.RECOMMENDATION, METHOD.GET_UNREAD_RECOMMS),
} as const;

export const FEEDBACK_ENDPOINTS = {
    FETCH_SHORT: buildEndpoint(ENTITY.FEEDBACK, METHOD.FETCH_SHORT),
    GET: buildEndpoint(ENTITY.FEEDBACK, METHOD.FETCH),
    CREATE: buildEndpoint(ENTITY.FEEDBACK, METHOD.CREATE),
    GET_FILE: buildEndpoint(ENTITY.FEEDBACK, METHOD.GET_FILE),
} as const;

export const FORM30_ENDPOINTS = {
    FETCH: '/form30',
    SAVE: '/form30',
    DELETE: '/form30',
    DASHBOARD: '/form30/dashboard',
} as const;